<template>
  <section v-intersect="onIntersect" :class="{fade: isIntersecting}" class="section sns" id="sns">
    <div class="section-wrapper">
      <h2 :class="{expandTitle: isIntersecting}" class="section-title">SNS</h2>
      <div class="underline"></div>
      <div class="content-wrapper">
        <div class="content">
          <a href="https://www.facebook.com/dogsalonfree">
            <h3 class="description-title">
              <font-awesome-icon :icon="['fab', 'facebook']"/>
               Facebook
            </h3>
          </a>
        </div>
        <div class="content">
          <a href="https://www.instagram.com/dogsalonfree/">
            <h3 class="description-title ">
              <font-awesome-icon :icon="['fab', 'instagram']"/>
               Instagram
            </h3>
          </a>
          <!-- <v&#45;btn -->
          <!--   @click="getPhotos" -->
          <!-- >データ取得</v&#45;btn> -->
          <SnsCards
            v-if="photos.length !== 0"
            :photos="photos"
          ></SnsCards>
          <ul id="gallery" class="gallery">
            <!-- <p>ここにInstagramの写真が入る予定。</p>
            <p>※東京に行ってからデキる人にやり方を聞く。</p>
            <p>セキュリティ上、サーバーなしでの運用は超危険なため</p>
            <p>有料サーバー必須のためレンタル代が必要</p> -->
          </ul>
          <div id="instafeed"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SnsCards from "@/components/main/SnsCards.vue";
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'Sns',
  data(){
    return {
      isIntersecting: false,
    }
  },
  computed: {
    ...mapGetters([
      'photos',
    ]),
  },
  created(){
    this.getPhotos()
  },
  methods: {
    ...mapActions([
      'getPhotos',
    ]),
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },

  },
  components: {
    SnsCards,
  }
}


</script>
